import { ref } from "vue"

const getEpisodes = ( rawepisodes ) => {
    const episodes = ref([null])

    const loadeps = async() => {

            if( rawepisodes ) {

                let promises = rawepisodes.map( async url => {
                    let ep = await fetch(url);
                    return ep.json()
                })

                episodes.value = await Promise.all(promises)

            }


    }

    return { episodes, loadeps }
}
export default getEpisodes